import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './BookingLink.css';

export interface IBookingLinkProps {
  landingUrl: string;
  onClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const BookingLink: React.FC<IBookingLinkProps> = ({ landingUrl, onClick }) => {
  return (
    <a className={styles['link']} href={landingUrl} onClick={onClick} target="_blank" rel="noopener noreferrer">
      <UIText2 color="current_color">Узнать о бронировании</UIText2>
    </a>
  );
};
